import type { FC } from 'react';

import { BlocksIcon } from 'lucide-react';

import Facebook from '@/components/atoms/Icons/Facebook';
import Infobip from '@/components/atoms/Icons/Infobip';
import Viber from '@/components/atoms/Icons/Viber';
import Whatsapp from '@/components/atoms/Icons/Whatsapp';
import Zendesk from '@/components/atoms/Icons/Zendesk';
import { Icon } from '@/shared/types/icon';
import { IntegrationType } from '@/shared/types/integration';

import { EmailIcon } from './EmailIcon';
import Front from './Front';
import IconInstagram from './Instagram';
import IconIntercom from './Intercom';
import IconLiveChat from './LiveChat';
import IconSmartlead from './Smartlead';
import IconSunco from './Sunco';
import TelnyxVoice from './TelnyxVoice';
import TwilioVoice from './TwilioVoice';
import IconWebWidget from './WebWidget';

export const integrationIconByType: Partial<Record<IntegrationType, FC<Icon>>> = {
  [IntegrationType.VIBER]: Viber,
  [IntegrationType.MSTAT_VIBER]: Viber,
  [IntegrationType.FACEBOOK]: Facebook,
  [IntegrationType.WHATSAPP]: Whatsapp,
  [IntegrationType.ZENDESK]: Zendesk,
  [IntegrationType.INTERCOM]: IconIntercom,
  [IntegrationType.LIVECHAT]: IconLiveChat,
  [IntegrationType.WEB]: IconWebWidget,
  [IntegrationType.INSTAGRAM]: IconInstagram,
  [IntegrationType.SUNCO]: IconSunco,
  [IntegrationType.FRONT]: Front,
  [IntegrationType.INFOBIP_SMS]: Infobip,
  [IntegrationType.INFOBIP_RCS]: Infobip,
  [IntegrationType.SMARTLEAD]: IconSmartlead,
  [IntegrationType.TWILIO_VOICE]: TwilioVoice,
  [IntegrationType.TELNYX_VOICE]: TelnyxVoice,
  [IntegrationType.EMAIL]: EmailIcon,
  [IntegrationType.CUSTOM]: BlocksIcon as FC<Icon>,
};
